import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AuthenticationService from './auth/AuthenticationService';
import * as serviceWorker from './serviceWorker';
import "react-ace";
import './themes/ace.css';

/* These imports must come after the react-ace import */
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-yaml";
import "ace-builds/src-noconflict/mode-sh";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-chrome";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/mode-powershell";

const authService = new AuthenticationService();
authService.login().then(() => {
  ReactDOM.render(
    <BrowserRouter><App authService={authService} /></BrowserRouter>,
    document.getElementById('root') as HTMLElement
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
